import { LiveCapitalLogo } from '@liveauctioneers/hammer-ui-liveauctioneers/liveCapitalLogo';

import LiveAuctioneersCapitalHeaderMeta from './LiveAuctioneersCapitalHeaderMeta';
import PageStyles from './styles';

const LiveAuctioneersCapital = () => {
    return (
        <PageStyles>
            <div className="pageHomepage">
                <LiveAuctioneersCapitalHeaderMeta />
                <section
                    className="bannerMedium banner"
                    id="banner"
                >
                    <div className="text">
                        <a className="logo">
                            <LiveCapitalLogo fill="black" />
                        </a>
                        <div className="border"></div>
                        <h1 className="mainHeading">Multiple financing solutions to help you grow your business</h1>
                        <p className="bannerText">
                            With one simple and secure application you can explore funding options from 75+ different
                            lenders and use the money to grow your business!
                        </p>
                        <p className="bannderText bannerTextBottom">
                            Your business is eligible if you have been in business for at least 6 months and have around
                            $10k in monthly revenue.
                        </p>
                        <button
                            className="startFunding btnOptions blue"
                            id="start-funding"
                        >
                            EXPLORE MY OPTIONS
                        </button>
                        <span className="securitySpan">
                            <p className="note">*There is no obligation and applying will NOT impact your credit!</p>
                            <img
                                alt="lock"
                                className="lock"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-lock.svg"
                            />
                            <img
                                alt="Security Badges"
                                className="securityBadges"
                                src="https://p1.liveauctioneers.com/dist/images/capital/img-security-badges.png"
                            />
                        </span>
                    </div>
                </section>

                <div className="blue fundOptions">
                    <div className="text">
                        <h2 className="heading">What you can use the funds for</h2>
                        <p className="subHeading">
                            The funds can be used for just about anything you need to help you grow your business!
                        </p>
                    </div>

                    <ul className="fundOptionsList">
                        <li>
                            <img
                                alt="checkbox"
                                className="checkIcon"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-tick.svg"
                            />
                            Mitigate cash flow issues
                        </li>
                        <li>
                            <img
                                alt="checkbox"
                                className="checkIcon"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-tick.svg"
                            />
                            Launch a marketing campaign
                        </li>
                        <li>
                            <img
                                alt="checkbox"
                                className="checkIcon"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-tick.svg"
                            />
                            Purchase more inventory
                        </li>
                        <li>
                            <img
                                alt="checkbox"
                                className="checkIcon"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-tick.svg"
                            />
                            Finance raw materials
                        </li>
                        <li>
                            <img
                                alt="checkbox"
                                className="checkIcon"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-tick.svg"
                            />
                            Hire new employees
                        </li>
                        <li>
                            <img
                                alt="checkbox"
                                className="checkIcon"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-tick.svg"
                            />
                            And much more!
                        </li>
                    </ul>
                </div>

                <div className="flowchart">
                    <h6 className="heading">
                        <span className="yellow"></span> LiveAuctioneers works with 75+ lenders to generate capital
                        offers that match your specific business needs
                    </h6>

                    <div className="boxesContainer">
                        <div className="box boxLeft">
                            <div className="listContainer metricsList">
                                <h6 className="listHeading blue">evaluation metrics</h6>
                                <ul>
                                    <li>Industry</li>
                                    <li>Risk Tier</li>
                                    <li>Revenue Metrics</li>
                                    <li>Use of Funds</li>
                                    <li>LiveAuctioneers Platform Data</li>
                                </ul>
                            </div>
                            <div className="listContainer sourcesList">
                                <h6 className="listHeading blue">Data sources</h6>
                                <ul>
                                    <li className="spanHalf">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source1.svg"
                                        />
                                    </li>
                                    <li className="spanHalf">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source2.svg"
                                        />
                                    </li>
                                    <li className="spanQuarter">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source4.svg"
                                        />
                                    </li>
                                    <li className="spanQuarter">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source5.svg"
                                        />
                                    </li>
                                    <li className="spanQuarter">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source6.svg"
                                        />
                                    </li>
                                    <li className="spanQuarter">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source7.svg"
                                        />
                                    </li>
                                    <li className="spanHalf">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source8.png"
                                        />
                                    </li>
                                    <li className="spanHalf">
                                        <img
                                            alt="Data Source Logo"
                                            src="https://p1.liveauctioneers.com/dist/images/capital/logo-source9.png"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="box boxMiddle">
                            <ul>
                                <li>
                                    <img
                                        alt="Company Logo"
                                        src="https://p1.liveauctioneers.com/dist/images/capital/logo-company1.png"
                                    />
                                </li>
                                <li>
                                    <img
                                        alt="Company Logo"
                                        src="https://p1.liveauctioneers.com/dist/images/capital/logo-company2.png"
                                    />
                                </li>
                                <li>
                                    <img
                                        alt="Company Logo"
                                        src="https://p1.liveauctioneers.com/dist/images/capital/logo-company3.png"
                                    />
                                </li>
                                <li>
                                    <img
                                        alt="Company Logo"
                                        src="https://p1.liveauctioneers.com/dist/images/capital/logo-company4.png"
                                    />
                                </li>
                                <li>
                                    <img
                                        alt="Company Logo"
                                        src="https://p1.liveauctioneers.com/dist/images/capital/logo-company5.png"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div className="box boxRight">
                            <div className="listContainer productsList">
                                <h6 className="listHeading green">CAPITAL Products</h6>
                                <ul>
                                    <li>Recievables Purchase</li>
                                    <li>Line of Credit</li>
                                    <li>Term Loan</li>
                                    <li>Invoice Factoring</li>
                                    <li>Instant Payout</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="howItWorks">
                    <h3 className="sectionHeading">How it works</h3>

                    <div className="howBoxesContainer">
                        <div className="howBox">
                            <img
                                alt="Icon Apply"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-apply.svg"
                            />
                            <h4 className="heading">Apply</h4>
                            <p className="text">
                                Fill out one simple application. There's no fee or obligation, and applying will not
                                impact your credit.{' '}
                            </p>
                        </div>
                        <div className="howBox">
                            <img
                                alt="Icon Evaluate"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-evaluate.svg"
                            />
                            <h4 className="heading">Evaluate</h4>
                            <p className="text">
                                Review your options and offers with your dedicated funding advisor and pick the solution
                                that works best for you.
                            </p>
                        </div>
                        <div className="howBox">
                            <img
                                alt="Icon Fund"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-fund.svg"
                            />
                            <h4 className="heading">Fund</h4>
                            <p className="text">
                                Get the capital you need in as little as 24 hours - wired directly into your business
                                bank account.
                            </p>
                        </div>
                        <div className="howBox">
                            <img
                                alt="Icon Grow"
                                src="https://p1.liveauctioneers.com/dist/images/capital/icon-grow.svg"
                            />
                            <h4 className="heading">Grow</h4>
                            <p className="text">
                                Put the money to work and get back to what you do best - growing your business!
                            </p>
                        </div>
                    </div>
                </div>

                <div className="howItHelps">
                    <h3 className="sectionHeading">How we help you</h3>

                    <div className="howBoxesContainer">
                        <div className="howBox">
                            <h3 className="sectionHeadingNumber">1</h3>
                            <p className="text">
                                Once you’ve completed the application, we’ll review your file and match you with
                                multiple lenders and show you offers so that you can pick the terms that work best for
                                you.
                            </p>
                        </div>
                        <div className="howBox">
                            <h3 className="sectionHeadingNumber">2</h3>
                            <p className="text">
                                You’ll get 1-on-1 guidance from an experienced funding advisor that will help you
                                understand your options and even negotiate with lenders on your behalf.{' '}
                            </p>
                        </div>
                        <div className="howBox">
                            <h3 className="sectionHeadingNumber">3</h3>
                            <p className="text">
                                We handle all the leg work to ensure you’re getting the best deal and can often get the
                                money into your account the same day it closes.{' '}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="cta">
                    <div className="text">
                        <h3 className="heading">Get funding for your business</h3>
                        <p className="subHeading">
                            Quick and easy access to flexible financing, so you can better manage your cash flow and
                            invest in growth
                        </p>
                        <button
                            className="btnCta startFunding2"
                            id="start-funding-2"
                        >
                            EXPLORE MY OPTIONS
                        </button>
                    </div>
                </div>
            </div>
        </PageStyles>
    );
};

export default LiveAuctioneersCapital;
